// UI组件
// import ViewUI from 'view-design';
// 字体图标
import '@/assets/font/iconfont.css';

import '@/assets/styles/myTheme.less';
// import zh from 'view-design/dist/locale/zh-CN';
import {
  // locale,
  ButtonGroup, Button,
  Table,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Icon,
  Row,
  Col,
  Tabs,
  TabPane,
  Tag,
  Layout,
  Header,
  Sider,
  Content,
  Menu,
  MenuItem,
  MenuGroup,
  Submenu,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Breadcrumb,
  BreadcrumbItem,
  Page,
  AutoComplete,
  Upload,
  Cascader,
  Avatar,
  DatePicker,
  RadioGroup,
  Radio,
  Message,
  Modal,
  Notice,
  Spin,
  LoadingBar,
  Tooltip,
  Carousel, CarouselItem,
  CheckboxGroup, Checkbox,
  Poptip,
  Collapse, Panel,
  Switch,
  Affix,
} from 'view-design';
// locale(zh);
// import ViewUI from 'view-design';

import VueClipboard from 'vue-clipboard2';
// 自定义组件
import MyFormItemField from '@/components/Form/FormItemField';
import MyFormItemList from '@/components/Form/FormItemList';
// import MyLayout from '@/components/Layout/index';
import MyBreadcrumb from '@/components/Layout/Breadcrumb';

const iviewUI = {
  ButtonGroup,
  Button,
  Table,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Icon,
  Row,
  Col,
  Tabs,
  TabPane,
  Tag,
  Layout,
  Header,
  Sider,
  Content,
  Menu,
  MenuItem,
  MenuGroup,
  Submenu,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Breadcrumb,
  BreadcrumbItem,
  Page,
  AutoComplete,
  Upload,
  Cascader,
  Avatar,
  DatePicker,
  RadioGroup,
  Radio,
  Message,
  Modal,
  Notice,
  Spin,
  LoadingBar,
  Tooltip,
  Carousel,
  CarouselItem,
  CheckboxGroup,
  Checkbox,
  Poptip,
  Collapse,
  Panel,
  iSwitch: Switch,
  Affix,
};

const MyUI = {
  MyFormItemField,
  MyFormItemList,
  // MyLayout,
  MyBreadcrumb,
};
const plugin = {
  install: (Vue) => {
    // view全局组件
    // Vue.use(ViewUI, {
    //         menu: {
    //             arrow: 'md-arrow-dropdown',
    //             arrowSize: '20'
    //         },
    //         select: {
    //             arrow: 'md-arrow-dropdown',
    //             arrowSize: '20'
    //         }
    //     })
    const opts = {
      menu: {
        arrow: 'md-arrow-dropdown',
        arrowSize: '20',
      },
      select: {
        arrow: 'md-arrow-dropdown',
        arrowSize: '20',
      },
    };
    Vue.prototype.$IVIEW = {
      size: opts.size || '',
      transfer: 'transfer' in opts ? opts.transfer : '',
      capture: 'capture' in opts ? opts.capture : true,
      select: {
        arrow: opts.select ? opts.select.arrow ? opts.select.arrow : '' : '',
        customArrow: opts.select ? opts.select.customArrow ? opts.select.customArrow : '' : '',
        arrowSize: opts.select ? opts.select.arrowSize ? opts.select.arrowSize : '' : '',
      },
      cell: {
        arrow: opts.cell ? opts.cell.arrow ? opts.cell.arrow : '' : '',
        customArrow: opts.cell ? opts.cell.customArrow ? opts.cell.customArrow : '' : '',
        arrowSize: opts.cell ? opts.cell.arrowSize ? opts.cell.arrowSize : '' : '',
      },
      menu: {
        arrow: opts.menu ? opts.menu.arrow ? opts.menu.arrow : '' : '',
        customArrow: opts.menu ? opts.menu.customArrow ? opts.menu.customArrow : '' : '',
        arrowSize: opts.menu ? opts.menu.arrowSize ? opts.menu.arrowSize : '' : '',
      },
      tree: {
        arrow: opts.tree ? opts.tree.arrow ? opts.tree.arrow : '' : '',
        customArrow: opts.tree ? opts.tree.customArrow ? opts.tree.customArrow : '' : '',
        arrowSize: opts.tree ? opts.tree.arrowSize ? opts.tree.arrowSize : '' : '',
      },
      cascader: {
        arrow: opts.cascader ? opts.cascader.arrow ? opts.cascader.arrow : '' : '',
        customArrow: opts.cascader ? opts.cascader.customArrow ? opts.cascader.customArrow : '' : '',
        arrowSize: opts.cascader ? opts.cascader.arrowSize ? opts.cascader.arrowSize : '' : '',
        itemArrow: opts.cascader ? opts.cascader.itemArrow ? opts.cascader.itemArrow : '' : '',
        customItemArrow: opts.cascader ? opts.cascader.customItemArrow ? opts.cascader.customItemArrow : '' : '',
        itemArrowSize: opts.cascader ? opts.cascader.itemArrowSize ? opts.cascader.itemArrowSize : '' : '',
      },
      colorPicker: {
        arrow: opts.colorPicker ? opts.colorPicker.arrow ? opts.colorPicker.arrow : '' : '',
        customArrow: opts.colorPicker ? opts.colorPicker.customArrow ? opts.colorPicker.customArrow : '' : '',
        arrowSize: opts.colorPicker ? opts.colorPicker.arrowSize ? opts.colorPicker.arrowSize : '' : '',
      },
      datePicker: {
        icon: opts.datePicker ? opts.datePicker.icon ? opts.datePicker.icon : '' : '',
        customIcon: opts.datePicker ? opts.datePicker.customIcon ? opts.datePicker.customIcon : '' : '',
        iconSize: opts.datePicker ? opts.datePicker.iconSize ? opts.datePicker.iconSize : '' : '',
      },
      timePicker: {
        icon: opts.timePicker ? opts.timePicker.icon ? opts.timePicker.icon : '' : '',
        customIcon: opts.timePicker ? opts.timePicker.customIcon ? opts.timePicker.customIcon : '' : '',
        iconSize: opts.timePicker ? opts.timePicker.iconSize ? opts.timePicker.iconSize : '' : '',
      },
      tabs: {
        closeIcon: opts.tabs ? opts.tabs.closeIcon ? opts.tabs.closeIcon : '' : '',
        customCloseIcon: opts.tabs ? opts.tabs.customCloseIcon ? opts.tabs.customCloseIcon : '' : '',
        closeIconSize: opts.tabs ? opts.tabs.closeIconSize ? opts.tabs.closeIconSize : '' : '',
      },
      modal: {
        maskClosable: opts.modal ? 'maskClosable' in opts.modal ? opts.modal.maskClosable : '' : '',
      },
    };
    Object.keys(iviewUI).forEach(ele => {
      Vue.component(ele, iviewUI[ele]);
    });
    Vue.prototype.$Loading = LoadingBar;
    Vue.prototype.$Message = Message;
    Vue.prototype.$Modal = Modal;
    Vue.prototype.$Notice = Notice;
    Vue.prototype.$Spin = Spin;

    Vue.use(VueClipboard);
    // 自定义全局组件
    Object.keys(MyUI).forEach(ele => {
      Vue.component(ele, MyUI[ele]);
    });
  },
};
export default plugin;
